import { PointTypeInteractor, PointTypeRequest, PointTypeStructRequest} from "../../Coordinator/PointType/PointTypeInteractor";

export class PointTypeViewModel {
    private interactor: PointTypeInteractor;

	constructor() {
		this.interactor = new PointTypeInteractor();
	}

    public fetchSave(obj: any): PromiseLike<any> {
        var request = new PointTypeRequest(
            obj["sgeptipoponto"] ? parseInt(obj["sgeptipoponto"]) : 0,
            obj["nome"] ? obj["nome"] : "",
			obj["itens"] ? obj["itens"] : []
        )
        
        return new Promise((res, rej) => {
			this.interactor.fetchSave(request).then((result) => {
				return res(true)
			}, e => {
				return rej(e)
			});
		})
    }

    public fetchDataOne(obj: any): PromiseLike<any> {
        var request = new PointTypeStructRequest(
            obj["sgeptipoponto"] ? parseInt(obj["sgeptipoponto"]) : 0
        )
        
        return new Promise((res, rej) => {
			this.interactor.fetchDataOne(request).then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
    }
}